// import {checkPower} from '@/assets/service/App';
// import {SET_PROJECT_INFO} from './mutation-types.js';

export default {
  // async checkPowerValidate({commit, state}, router) {
  //   return new Promise((resolve, reject) => {
  //     checkPower({router}).then(res => {
  //       commit(SET_PROJECT_INFO, res);
  //       resolve(res);
  //     }).catch(err => {
  //       reject(err);
  //     });
  //   });
  // }
}

